import { render, staticRenderFns } from "./BreadcrumbList.vue?vue&type=template&id=fb4d25de&scoped=true"
var script = {}
import style0 from "./BreadcrumbList.vue?vue&type=style&index=0&id=fb4d25de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4d25de",
  null
  
)

export default component.exports